module.exports = __webpack_public_path__ + "img/logo.10171096.png";